export class MathHelper {
    static async round(val, precision) {
        return Math.round(val * Math.pow(10, precision)) / Math.pow(10, precision);
    }
}